"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountsConfirmRole = void 0;
const modal_form_component_1 = require("../../components/modal.form/modal.form.component");
const index_1 = require("../../i18n/index");
const ACCOUNTS_SET_ROLE_SUCCESS = { key: index_1.T.ACCOUNTS_SET_ROLE_SUCCESS };
class AccountsConfirmRole extends modal_form_component_1.ModalFormComponent {
    constructor(ctrl, user, role) {
        super({
            title: index_1.T.ACCOUNTS_SET_ROLE_TITLE,
            confirm: index_1.T.ACCOUNTS_SET_ROLE,
            success: ACCOUNTS_SET_ROLE_SUCCESS,
        });
        this.ctrl = ctrl;
        this.user = user;
        this.role = role;
    }
    get nodes() {
        const role = this.role === 'root' ? 'admin' : this.role;
        return (0, index_1.Translate)(index_1.T.ACCOUNTS_SET_ROLE_CONFIRM, { username: this.user.username, role });
    }
    submit() {
        return this.ctrl.setUserRole(this.user, this.role);
    }
    failToChange() {
        this.ctrl.setLoading(this.user.objectId, false);
    }
}
exports.AccountsConfirmRole = AccountsConfirmRole;
//# sourceMappingURL=accounts.confirm.role.js.map